// import { formatRole } from '@/helpers/permission'
import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingPermissionList: false,
  dataListPermission: [],
});

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    LOAD_ROLE_LIST: (s, data) => (s.loadingPermissionList = data),
    SET_LIST_PERMISSION: (s, data) => (s.dataListPermission = data),
  },

  actions: {
    async getPermissionList({ commit }, params) {
      commit("LOAD_ROLE_LIST", true);
      try {
        const res = await this.$api.get("/v1/portal/permissions", { params });
        const data = res.data.data;
        commit("SET_LIST_PERMISSION", data);
        return data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_ROLE_LIST", false);
      }
    },
  },
};
